import React, { useEffect, useState } from 'react'; // eslint-disable-line
import { documentService } from '../utils/window.utils.js';

const useStickyWrapper = () => {
  const [stickyWrapperEle, setStickyWrapperEle] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setStickyWrapperEle(documentService()?.getElementById?.('sticky-top-wrapper'));
  }, []);

  return stickyWrapperEle;
};

export default useStickyWrapper;
